import Layout from '@/layout'

const userManage = {
    path: '/user',
    component: Layout,
    children: [

        // 认证审核
        {
            path: 'certificationList',
            name: 'certificationList',
            component: () => import('@/views/doctor/user/certificationList'),
            meta: { activeMenu: '/user/certificationList' }
        },
        {
            path: 'certificateDetail',
            name: 'certificateDetail',
            component: () => import('@/views/doctor/user/certificateDetail'),
            meta: { activeMenu: '/user/certificationList' }
        },

        // 用户列表
        {
            path: 'userList',
            name: 'userList',
            component: () => import('@/views/doctor/user/userList'),
            meta: { activeMenu: '/user/userList' }
        },
        // 医生用户详情
        {
            path: 'userList/detail',
            name: 'userDetail',
            component: () => import('@/views/doctor/user/userDetail'),
            meta: { activeMenu: '/user/userList' }
        },
        // 新增医生用户
        {
            path: 'userList/add',
            name: 'userAdd',
            component: () => import('@/views/doctor/user/userAdd'),
            meta: { activeMenu: '/user/userList' }
        },
        // 护士用户详情
        {
            path: 'userList/detail/nurse',
            name: 'nurseDetail',
            component: () => import('@/views/doctor/user/nurseDetail'),
            meta: { activeMenu: '/user/userList' }
        },
        // 新增护士用户
        {
            path: 'userList/add/nurse',
            name: 'nurseAdd',
            component: () => import('@/views/doctor/user/nurseAdd'),
            meta: { activeMenu: '/user/userList' }
        },
        // 注册管理-列表
        {
            path: 'registerList',
            name: 'registerList',
            component: () => import('@/views/doctor/user/registerList'),
            meta: { activeMenu: '/user/registerList' }
        },
        // 注册管理-认证详情
        {
            path: 'registerDetail',
            name: 'registerDetail',
            component: () => import('@/views/doctor/user/registerDetail'),
            meta: { activeMenu: '/user/registerList' }
        },
        // 反馈统计
        {
            path: 'feedbackList',
            name: 'feedbackList',
            component: () => import('@/views/doctor/user/feedbackList'),
            meta: { activeMenu: '/user/feedbackList' }
        }
    ]
}

export default userManage
